import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új esemény',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "eventRegistrationType",
                label: "Típus",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "sourceType",
                label: "Forrástípus",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "applicantName",
                label: "Eseményt kérelmező neve",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "eventDateFrom",
                label: "Dátumtól",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "eventDateTo",
                label: "Dátumig",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "eventRegistrationType",
                label: "Típus",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "sourceType",
                label: "Forrástípus",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "applicantName",
                label: "Eseményt kérelmező neve",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "eventDate",
                label: "Dátum",
                sort: true,
                visibility: true,
                slot_name: "date_format",
                formType: 'date',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "personalDataCategories",
                label: "Kezelt személyes adatok kategóriái",
                visibility: false,
                formSize: 12,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllEventRegistrationPersonalDataCategoryFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
